/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 2.35.1025 on 2023-07-05 16:03:16.
export interface PackageResource {
    uuid: string;
    title: string;
    iconBase64: string;
    name: string;
    version: string;
    status: Status<PackageStatus>;
    features: PackageFeatureResource[];
    pluginId: number;
    pluginState: ElementState;
    enabled: boolean;
    typesMetadata: { [index: string]: EntityTypeMetadata };
    requiredPlugins: PluginRequirementWithState[];
    requiredEntities: EntityRequirementWithState[];
}

export interface EntityFeatureResource {
    uuid: string;
    type: string;
    name: string;
    version: string;
    label: string;
    packageId: string;
    packageTitle: string;
    packageIconBase64: string;
    packageName: string;
    packageVersion: string;
}

export interface PackageUpdateInput {
    enabled: boolean;
    featuresEnabled: { [index: string]: boolean };
    featuresSettings: { [index: string]: Record<string, unknown> };
}

export interface ElementState {
    status: ElementStatus;
    messages: string[];
    metrics: { [index: string]: any };
    valid: boolean;
}

export interface QueryResponse {
    channel: string;
}

export interface Status<E> {
    flags: E[];
    messages: string[];
}

export interface PackageFeatureResource {
    uuid: string;
    type: string;
    name: string;
    version: string;
    label: string;
    settings: Record<string, unknown>;
    status: Status<FeatureStatus>;
    installed: InstallationRecordWithState;
    enabled: boolean;
    readme: string;
    changelog: { [index: string]: string };
}

export interface EntityTypeMetadata {
    manifestFeaturesKey: string;
    contentSchema: Record<string, unknown>;
    settingsSchema: Record<string, unknown>;
    entityTypeUrl: string;
}

export interface PluginRequirementWithState extends PluginRequirement {
    state: ElementState;
}

export interface EntityRequirementWithState extends EntityRequirement {
    state: ElementState;
    entity: any;
}

export interface InstallationRecordWithState extends InstallationRecord {
    entityState: ElementState;
}

export interface PluginRequirement {
    name: string;
    version: string;
    optional: boolean;
}

export interface EntityRequirement {
    type: string;
    key: string;
}

export interface EntityMapping {
    type: string;
    key: string;
    url: string;
}

export interface InstallationRecord {
    entityMapping: EntityMapping;
    timestamp: number;
    packageVersion: string;
    featureVersion: string;
}

export interface PackageManagerHttpServices {

    /**
     * HTTP GET /installed/feature
     * Java method: net.intelie.live.plugin.packagemanager.PackageManagerHttpServices.searchEntityByUUid
     */
    searchEntityByUUid(uuid: string, type: string): RestResponse<{id: number}>;

    /**
     * HTTP GET /installed/feature
     * Java method: net.intelie.live.plugin.packagemanager.PackageManagerHttpServices.searchFeature
     */
    searchFeature(queryParams?: { entityType?: string; entityKey?: string; }): RestResponse<EntityFeatureResource>;

    /**
     * HTTP GET /package/{uuid}
     * Java method: net.intelie.live.plugin.packagemanager.PackageManagerHttpServices.getPackage
     */
    getPackage(uuid: string): RestResponse<PackageResource>;

    /**
     * HTTP DELETE /package/{uuid}
     * Java method: net.intelie.live.plugin.packagemanager.PackageManagerHttpServices.unregisterPackage
     */
    unregisterPackage(uuid: string): RestResponse<any>;

    /**
     * HTTP POST /package/{uuid}
     * Java method: net.intelie.live.plugin.packagemanager.PackageManagerHttpServices.updatePackage
     */
    updatePackage(uuid: string, arg1: PackageUpdateInput): RestResponse<PackageResource>;

    /**
     * HTTP GET /package/{uuid}/download/current-installed
     * Java method: net.intelie.live.plugin.packagemanager.PackageManagerHttpServices.downloadCurrentState
     */
    downloadCurrentState(uuid: string): RestResponse<any>;

    /**
     * HTTP POST /package/{uuid}/install
     * Java method: net.intelie.live.plugin.packagemanager.PackageManagerHttpServices.installPackage
     */
    installPackage(uuid: string): RestResponse<void>;

    /**
     * HTTP POST /package/{uuid}/uninstall
     * Java method: net.intelie.live.plugin.packagemanager.PackageManagerHttpServices.uninstallPackage
     */
    uninstallPackage(uuid: string): RestResponse<void>;

    /**
     * HTTP GET /packages
     * Java method: net.intelie.live.plugin.packagemanager.PackageManagerHttpServices.getPackages
     */
    getPackages(): RestResponse<PackageResource[]>;

    /**
     * HTTP POST /packages/changes-channel
     * Java method: net.intelie.live.plugin.packagemanager.PackageManagerHttpServices.listenForChanges
     */
    listenForChanges(): RestResponse<QueryResponse[]>;
}

export interface HttpClient {

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; }): RestResponse<R>;
}

export class PackageManagerHttpServicesClient implements PackageManagerHttpServices {

    constructor(protected httpClient: HttpClient) {
    }

     /**
     * HTTP GET /installed/feature
     * Java method: net.intelie.live.plugin.packagemanager.PackageManagerHttpServices.searchEntityByUUid
     */
    async searchEntityByUUid(uuid: string, type:  string): RestResponse<{ id: number; }> {

        const endpoint = new URL(`/services/plugin-package-manager/${uuid}/entity`, window.location.origin)
        endpoint.searchParams.append('type', type)

        const response = await fetch(endpoint)

        if(!response.ok) return null
        
        return response.json()
    }

    /**
     * HTTP GET /installed/feature
     * Java method: net.intelie.live.plugin.packagemanager.PackageManagerHttpServices.searchFeature
     */
    searchFeature(queryParams?: { entityType?: string; entityKey?: string; }): RestResponse<EntityFeatureResource> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`installed/feature`, queryParams: queryParams });
    }

    /**
     * HTTP GET /package/{uuid}
     * Java method: net.intelie.live.plugin.packagemanager.PackageManagerHttpServices.getPackage
     */
    getPackage(uuid: string): RestResponse<PackageResource> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`package/${uuid}` });
    }

    /**
     * HTTP DELETE /package/{uuid}
     * Java method: net.intelie.live.plugin.packagemanager.PackageManagerHttpServices.unregisterPackage
     */
    unregisterPackage(uuid: string): RestResponse<any> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`package/${uuid}` });
    }

    /**
     * HTTP POST /package/{uuid}
     * Java method: net.intelie.live.plugin.packagemanager.PackageManagerHttpServices.updatePackage
     */
    updatePackage(uuid: string, arg1: PackageUpdateInput): RestResponse<PackageResource> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`package/${uuid}`, data: arg1 });
    }

    /**
     * HTTP GET /package/{uuid}/download/current-installed
     * Java method: net.intelie.live.plugin.packagemanager.PackageManagerHttpServices.downloadCurrentState
     */
    downloadCurrentState(uuid: string): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`package/${uuid}/download/current-installed` });
    }

    /**
     * HTTP POST /package/{uuid}/install
     * Java method: net.intelie.live.plugin.packagemanager.PackageManagerHttpServices.installPackage
     */
    installPackage(uuid: string): RestResponse<void> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`package/${uuid}/install` });
    }

    /**
     * HTTP POST /package/{uuid}/uninstall
     * Java method: net.intelie.live.plugin.packagemanager.PackageManagerHttpServices.uninstallPackage
     */
    uninstallPackage(uuid: string): RestResponse<void> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`package/${uuid}/uninstall` });
    }

    /**
     * HTTP GET /packages
     * Java method: net.intelie.live.plugin.packagemanager.PackageManagerHttpServices.getPackages
     */
    getPackages(): RestResponse<PackageResource[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`packages` });
    }

    /**
     * HTTP POST /packages/changes-channel
     * Java method: net.intelie.live.plugin.packagemanager.PackageManagerHttpServices.listenForChanges
     */
    listenForChanges(): RestResponse<QueryResponse[]> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`packages/changes-channel` });
    }
}

export type RestResponse<R> = Promise<R>;

export type PackageStatus = "INSTALLED" | "NOT_INSTALLED" | "INVALID";

export type ElementStatus = "INACTIVE" | "INVALID" | "STARTING" | "VALID_BUT" | "VALID" | "NEW";

export type FeatureStatus = "NOT_INSTALLED" | "INSTALLED" | "INVALID" | "DIFFERENT_CONTENT_INSTALLED";

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
    let result = "";
    for (let i = 0; i < substitutions.length; i++) {
        result += template[i];
        result += encodeURIComponent(substitutions[i]);
    }
    result += template[template.length - 1];
    return result;
}


export interface PerspectiveApi{
    list(): Promise<{id: number, name: string}[]>
}

export class PerspectiveClient implements PerspectiveApi {
    URI: string = '/rest/perspective'

    async list(): Promise<{ id: number; name: string; }[]> {        
        const endpoint = new URL(this.URI, window.location.origin);        
        
        const response = await fetch(endpoint);
        
        if (!response.ok) return []
    
        return await response.json();
    }
}

export interface DashboardApi {
    listByName(name: string): Promise<{id: number, title: string}[]>
}

export class DashboardClient implements DashboardApi {
    URI: string = '/rest/dashboard'
    
    async list(name: string, archived = false){
        const endpoint = new URL(this.URI, window.location.origin)

        //TODO - After update live to version 3.51.x use the queryParam 'title' because will provider exact match
        endpoint.searchParams.append('query', name)
        endpoint.searchParams.append('archived', `${archived}`)

        const responseArchivedes = await fetch(endpoint)

        if (!responseArchivedes.ok) return {data: []}

        return await responseArchivedes.json() || {data: []}
    }

    async listByName(name: string): Promise<{ id: number; title: string; }[]> {
        const jsonArchivedes = await this.list(name, true)
        const jsonNotArchivedes = await this.list(name, false)
        const dashboardsDB = jsonArchivedes.data.concat(jsonNotArchivedes.data) 
        
        return new Promise(res => {
            const dashboards = dashboardsDB.filter(dashboard => dashboard.title === name)            
            res(dashboards)
        })
    }
   
}
